import React, { useState } from 'react';
import { Button, Card, styled, Typography } from '@harver/shared-ui';

import { useContent } from '../../branding/content.context';

const StyledCard = styled(Card)`
    display: flex;
    flex-direction: column;
    align-items: end;
    position: fixed;
    bottom: ${({ theme }) => theme.sizes.medium};
    right: ${({ theme }) => theme.sizes.medium};
    border-radius: ${({ theme }) => theme.getSpacing(2)};
    width: 30%;

    @media (max-width: 768px) {
        width: 95%;
    }
`;

const StyledButton = styled(Button)`
    margin-top: ${({ theme }) => theme.getSpacing(5)};
`;

const CookieBanner = (): JSX.Element | null => {
    const { cookieBanner: LANG } = useContent();
    const [showBanner, setShowBanner] = useState(true);

    const handleAccept = () => {
        setShowBanner(false);
        // Store the user's response in a cookie
        document.cookie = 'scheduling_cookie_accepted=true; max-age=1210000; path=/'; // Expires in 14 days
    };

    // Check if the user has already accepted cookies
    const cookiesAccepted = document.cookie.includes('scheduling_cookie_accepted=true');

    return !cookiesAccepted && showBanner ? (
        <StyledCard>
            <Typography cs={{ marginRight: 'auto' }} variant="body1">
                {LANG.p1}
            </Typography>
            <StyledButton onClick={handleAccept}>{LANG.button}</StyledButton>
        </StyledCard>
    ) : null;
};

export default CookieBanner;
